import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'none',
      padding: theme.spacing(2),
      height: '54px',

      '&:disabled': {
        opacity: '0.5',
      },

      [theme.breakpoints.up('md')]: {
        height: '40px',
      },
    },
    round: {
      borderRadius: theme.spacing(4),
    },
    transparent: {
      background: 'transparent',
      border: '1px solid rgba(26, 17, 24, 0.3)'
    },
    gradient: {
      background: 'linear-gradient(90deg, #3F52FA 0%, #3D8CFC 100%)',
    },
    black: {
      background: 'black',
      '&:hover': {
        background: 'black',
        opacity: '0.8'
      },
    },
  })
);
